// extracted by mini-css-extract-plugin
export default {"ProfileWaitingPage__text":"ProfileWaiting_ProfileWaitingPage__text__7q7EL"};